import Config from 'services/config/config';
import callWebService, {callTypes} from 'services/utils/networks/network';
import {ASSETS_VERIFICATION, BARCODE_HISTORY, CONTRACT_LIST, GATE_LIST, MAPPED_MATERIAL} from "./type";

export const getContractList = (filterData, page = 1) => async (dispatch) => {
    dispatch({
        type: CONTRACT_LIST,
        payload: [],
    });
    const res = await callWebService(
        callTypes.get,
        '',
        filterData=== null ? `${Config.contractAssetsMapping.contractList}?page=${page}` :`${Config.contractAssetsMapping.contractList}?site_no=${filterData.site_no}&client_name=${filterData.client_name}&site_type=${filterData.site_type}&assignee_ids=${filterData.reportee}&area_id=${filterData.area_id}&status_id=${filterData.status_id}&city_id=${filterData.city_id}&commercial_type_id=${filterData.commercial_type_id}&from_date=${filterData.from_date}&to_date=${filterData.to_date}&page=${page}`
    );
    if (res?.data?.response?.status === true) {
        const {data} = res;
        dispatch({
            type: CONTRACT_LIST,
            payload: data?.response?.data,
        });
    } else {
        return res;
    }
};

export const getGateList = (comm_id, lead_id) => async (dispatch) => {
    dispatch({
        type: GATE_LIST,
        payload: [],
    });
    const res = await callWebService(
        callTypes.get,
        '',
        Config.contractAssetsMapping.gateList + "?comm_id=" + comm_id + "&lead_id=" + lead_id
    );
    if (res?.data?.response?.status === true) {
        const {data} = res;
        dispatch({
            type: GATE_LIST,
            payload: data?.response?.data,
        });
    } else {
        return res;
    }
};

export const getMaterialForGateList = (assetsMappingId, gateId) => async (dispatch) => {
    dispatch({
        type: MAPPED_MATERIAL,
        payload: [],
    });
    const res = await callWebService(
        callTypes.get,
        '',
        Config.contractAssetsMapping.materialList + "?assets_mapping_id=" + assetsMappingId + "&gate_id=" + gateId
    );
    if (res?.data?.response?.status === true) {
        const {data} = res;
        dispatch({
            type: MAPPED_MATERIAL,
            payload: data?.response?.data,
        });
    } else {
        return res;
    }
};

export const saveBarcodeHistory = (data) => async (dispatch) => {
    dispatch({
        type: BARCODE_HISTORY,
        payload: [],
    });
    const res = await callWebService(
        callTypes.post,
        data,
        Config.contractAssetsMapping.barcodeHistory
    );
    if (res?.data?.response?.status === true) {
        const {data} = res;
        dispatch({
            type: BARCODE_HISTORY,
            payload: data,
        });
    } else {
        return res;
    }
};

export const saveSiteVerification = (data) => async (dispatch) => {
    dispatch({
        type: ASSETS_VERIFICATION,
        payload: [],
    });
    const res = await callWebService(
        callTypes.post,
        data,
        Config.contractAssetsMapping.siteAssetsVerification
    );
    if (res?.data?.response?.status === true) {
        const {data} = res;
        dispatch({
            type: ASSETS_VERIFICATION,
            payload: data,
        });
    } else {
        return res;
    }
};